// GET /admin/api/2021-01/collections/{collection_id}/products.json
const app = {}

document.addEventListener("DOMContentLoaded", () => {
           let resultz;
Darn(getProducts);
  async function Darn(callback) {
  let request = new Request("https://nutsac.com/collections/everyday-bags/products.json?limit=500")
      let response = await fetch(request)
      let json = await response.json();
	console.log(json)
    setStorage(JSON.stringify(json))

   
    callback(json.products, getVariants);
  }


  function getProducts (items, callback) {
    items.forEach(item => {
          callback(item.variants);
          })

  }

  function getVariants (items) {
    items.forEach(item => {
          console.log(item)
          })
  }

  function setStorage(json) {
      localStorage.setItem("app", ""+json+"")
  }


})



